<!-- Side Panel left -->
@if (widgetId) {
  <div #sidePanel id="vesselboard-{{widgetId}}" class="adx-sidepanel" aria-label="side panel" aria-hidden="false">
    <div class="adx-sidepanel-inner-wrapper">
      <div class="adx-sidepanel-content-wrapper">
        <div class="sidepanel-content">
          <div class="vessel-items-list">
            <div class="vessel-board-title">
              <h3>{{ 'MAP.SIDE_PANEL.OVERVIEW_SHIP_DETAILS' | translate }}</h3>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Vessel..." #input [(ngModel)]="searchFilterValue">
              @if (searchFilterValue) {
                <button mat-icon-button matSuffix class="adx-custom-mat-suffix-icon-button" (click)="clearSearchFilter()">
                  <fa-icon [icon]="'xmark'"></fa-icon>
                </button>
              }
            </mat-form-field>
            <!-- Checkbox Column -->
            <table mat-table [dataSource]="dataSource" [trackBy]="trackById" class="mat-elevation-z2" matSort>
              <ng-container matColumnDef="selected_vessel_item">
                <th mat-header-cell *matHeaderCellDef class="table-header-bold">
                  <fa-icon [icon]="'ship'"></fa-icon>
                </th>
                <td mat-cell *matCellDef="let row" [class.vessel-item-row-is-clicked]="vesselItemSelection.isSelected(row)">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? vesselItemSelection.toggle(row) : null"
                    [checked]="vesselItemSelection.isSelected(row)"
                    [aria-label]="onRowClicked(row)"
                    >
                  </mat-checkbox>
                </td>
              </ng-container>
              <!-- Dynamic Columns -->
              @for (column of columns; track column) {
                <ng-container
                  [matColumnDef]="column.columnDef"
                  >
                  <th mat-header-cell *matHeaderCellDef  mat-sort-header class="table-header-bold"> {{ column.header }} </th>
                  <td mat-cell
                    *matCellDef="let row"
                    [class.vessel-item-row-is-clicked]="vesselItemSelection.isSelected(row)"
                    [ngClass]="getClassForValue(column.columnDef)"
                    >
                    {{ column.cell(row) }}
                  </td>
                </ng-container>
              }
              <!-- Header and Row Declarations -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No Match "{{ input.value }}"</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="adx-sidepanel-toggle-container">
        <button class="adx-sidepanel-toggle-button" type="button" aria-label="toggle side panel"></button>
      </div>
    </div>
  </div>
}
